import axiosInstance from "../utils/axios/axios";
import privateAxiosInstance from "../utils/axios/private";
import { hybridEncrypt, hybridDecrypt } from "../utils/crypto";

export const configurationApi = {
    /**
     * Create or update configuration (POST)
     */
    async saveConfiguration(payload) {
        try {
            const encryptedPayload = await hybridEncrypt(payload);
            const response = await privateAxiosInstance.post("/configuration/", encryptedPayload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        }
        catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * Get configuration details (GET)
     */
    async getConfiguration() {
        try {
            const response = await privateAxiosInstance.get("/configuration/");
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        }
        catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },
};
